import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".loader-module_loaderWrapper__jul-k {\n  min-height: 70vh;\n  display: flex;\n  justify-content: center;\n}\n.loader-module_loaderWrapper__jul-k > * {\n  flex: 1;\n}\n.loader-module_loaderWrapper__jul-k > * > * {\n  background-color: transparent;\n}";
var styles = {"loaderWrapper":"loader-module_loaderWrapper__jul-k"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=loader.module.scss.js.map
